var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-xl-3 mb-3"
  }, [_c('h5', {
    staticClass: "title-section"
  }, [_vm._v("Enrollment by Top " + _vm._s(_vm.memberDataByStates.length) + " States")]), _c('div', {
    staticClass: "overallInfo-blockWrapper noHeight dashboard-card p-3 pb-2"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.memberDataByStates, function (item) {
    return _c('tr', {
      key: item.state
    }, [_c('td', [_vm._v(_vm._s(item.state))]), _c('td', [_vm._v(_vm._s(item.percentage))])]);
  }), 0)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("State")]), _c('th', [_vm._v("Enrolled (in %)")])])]);
}]

export { render, staticRenderFns }